module.exports = __webpack_public_path__ + "img/maleBrown.a6cb08ca.png";